import { CreateAccountRequestBody } from "@syla/shared/types/requests/CreateAccountRequest";
import { CreateAccountResponse } from "@syla/shared/types/responses/CreateAccountResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function createAccount(
  props: CreateAccountRequestBody,
): Promise<CreateAccountResponse> {
  try {
    const response = await axios.post<CreateAccountResponse>(
      `/accounts`,
      props,
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
